import React from 'react'
import {getFormComponent} from '../../services/utils/formUtils'
import {useFormContext} from 'react-hook-form'

const FormField = ({field, i18n, arrayName, index}) => {
    const {name} = field
    const fieldName = arrayName ? `${arrayName}[${index}].${name}` : name
    // delete field.defaultValueFieldName
    const {
        watch,
        formState: {errors},
    } = useFormContext()
    const ComponentField = getFormComponent(field?.type)
    const defaultValue = watch(fieldName)
    const error = arrayName ? errors?.[arrayName]?.[index]?.[name] : errors[fieldName]
    return (
        <ComponentField
            {...field}
            name={fieldName}
            label={field?.label || field?.name}
            i18nCategory={i18n}
            defaultValue={defaultValue}
            error={error}
        />
    )
}

export default FormField
